/**
 * app/probe-door.ts — the launch `startapp=proba` leaves the app for the probe of two decks,
 * `startapp=probapult` for the probe of the pult (task 53), and `startapp=probavideo` for the probe
 * of clips in a row (task 74).
 *
 * Task 42. The probe (`apps/web/proba.html`) has to run inside Telegram's own webview on two
 * phones, and a Mini App's address is the one BotFather holds — so the way in is a launch of the
 * app with this payload, which then hands the page over. The payload is read from the session the
 * server signed (`store/session.ts`), like every other: the address bar's copy is unsigned.
 *
 * The hash goes along: it carries the launch data, and the probe signs in with them.
 */

/** The payload of `t.me/<бот>/<приложение>?startapp=proba`. */
export const PROBE_START_PARAM = 'proba';

/** The probe page, beside `index.html` in the build. */
export const PROBE_PATH = '/proba.html';

/** Task 53: the probe of the pult — `startapp=probapult`, its own page beside the other. */
export const PULT_PROBE_START_PARAM = 'probapult';
export const PULT_PROBE_PATH = '/proba-pulta.html';

/** Task 74: does the next clip of «Видео» start by itself — `startapp=probavideo`. */
export const VIDEO_PROBE_START_PARAM = 'probavideo';
export const VIDEO_PROBE_PATH = '/proba-video.html';

const PAGES: Readonly<Record<string, string>> = Object.freeze({
  [PROBE_START_PARAM]: PROBE_PATH,
  [PULT_PROBE_START_PARAM]: PULT_PROBE_PATH,
  [VIDEO_PROBE_START_PARAM]: VIDEO_PROBE_PATH,
});

export function isProbeLaunch(startParam: string | null | undefined): boolean {
  return startParam !== null && startParam !== undefined && Object.hasOwn(PAGES, startParam);
}

/** Where the page goes: the probe the launch names, with the launch data of this one. */
export function probeAddress(hash: string, startParam: string = PROBE_START_PARAM): string {
  return `${PAGES[startParam] ?? PROBE_PATH}${hash}`;
}
